import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideoOn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconVideoOn"><Path fillRule="evenodd" clipRule="evenodd" d="M2 5.75C2 4.7835 2.7835 4 3.75 4H15.25C16.2165 4 17 4.7835 17 5.75V7.48155L19.4066 6.15789C20.5729 5.51643 22 6.36022 22 7.69127V16.3087C22 17.6398 20.5729 18.4836 19.4066 17.8421L17 16.5185V18.25C17 19.2165 16.2165 20 15.25 20H3.75C2.7835 20 2 19.2165 2 18.25V5.75ZM9.5 15C11.1569 15 12.5 13.6569 12.5 12C12.5 10.3431 11.1569 9 9.5 9C7.84315 9 6.5 10.3431 6.5 12C6.5 13.6569 7.84315 15 9.5 15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideoOn;
